import React, {useCallback, useState} from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import BodyTree from './BodyTree';
import {labels} from '../../../../../../util/utils';
import {entities, OperationTypes} from '../../../../../../util/uiconstants';
import Utility from '../../../../../../util/utilityfunctions';
import {cloneDeep} from 'lodash';
import {useUserPreferences} from '../../../../../../util/customHooks';
import {updateFormBodyRelatedObject} from '../../../../../../actions/FormData/formdataactions';
import CreateEditEntityModal from '../../../../../Common/EntityCrud/CreateEditEntityModal';
import { useDispatch } from 'react-redux';

export default function ITProcessRelatedObject(props) {
	const {isTopLevel, bodyId, isSnapshotView} = props;
	
	const dispatch = useDispatch();

	let data = cloneDeep(props.data);

	if (data.hasOwnProperty('children') && data.children?.length > 0) {
		data.children = data.children.map((item) => {
			return {
				...item,
				parentEntityId: Number(data.entityUId)
			};
		});
	}

	const currentLevel = isTopLevel ? 1 : data.level;

	const userPreferences = useUserPreferences();

	const [showModal, setShowModal] = useState(false);

	const onClick = useCallback(() => {
		if (!isSnapshotView) {
			setShowModal(true);
		}
	}, [isSnapshotView]);

	const itProcessSelector = (state) => {
		return {
			...data,
			itProcessName: data.entityName,
		};
	};

	const handleOnEntityModified = useCallback((itProcess) => {
		const actionPayload = {
			...itProcess,
			bodyId: bodyId,
			entityId: entities.ItProcess,
			entityUId: itProcess.id,
			entityName: itProcess.itProcessName
		};
		return dispatch(updateFormBodyRelatedObject(actionPayload, OperationTypes.update));
	}, [bodyId]);

	return (
		<StyledITProcessRelatedObject
			className={`ITProcessRelatedObject entity-content entity-content-level-${currentLevel}`}
		>
			<>
				<BodyTree data={data} bodyId={bodyId} noChildrenLabel={labels.formsNoRelatedObjects} open>
					<section
						className={`entity-content-main ITProcessRelatedObjectWrapper ${Utility.getClasstoDisableADCLink(
							userPreferences,
							isSnapshotView
						)}`}
						//onClick={onClick}
					>
						<>
							{currentLevel === 1 ? (
								<>
									<section className="RelatedObjectTextWrapper" onClick={onClick}>
										<EllipsesControl
											content={Utility.getHtmlTextElement(data.entityName, isSnapshotView)}
											tooltip={Utility.getHtmlTextElement(data.entityName, isSnapshotView)}
											noOfLines={1}
										/>
									</section>
									{data && data.children && data.children.length > 0 && (
										<span className="CountWrapper">
											<span>{Number(data.children.length)}</span>
										</span>
									)}
								</>
							) : (
								<section className="RelatedObjectTextWrapper" onClick={onClick}>
									<span>{Utility.getHtmlTextElement(data.entityName, isSnapshotView)}</span>
									{data && data.children && data.children.length > 0 && (
										<span className="CountWrapper">
											<span>{Number(data.children.length)}</span>
										</span>
									)}
								</section>
							)}
						</>
					</section>
				</BodyTree>
				{!isSnapshotView && (
					<CreateEditEntityModal
						entityType={data?.entityId}
						entityId={data?.entityUId}
						entitySelector={itProcessSelector}
						showCreateEditEntityModal={showModal}
						setShowCreateEditEntityModal={setShowModal}
						onEntityModified={handleOnEntityModified}
					/>
				)}
			</>
		</StyledITProcessRelatedObject>
	);
}

const StyledITProcessRelatedObject = styled.section`
	button {
		.motif-tree-trigger-icon {
			display: none;
		}
	}
	.tree-trigger-children {
		width: calc(100% - var(--px-20)) !important;
	}
	.entity-content-main {
		width: 100% !important;
		align-items: flex-start;
		.RelatedObjectTextWrapper {
			max-width: calc(100% - var(--px-40)) !important;
		}
		&.ITProcessRelatedObjectWrapper {
			&.disableLinksExternalUsers {
				pointer-events: none;
			}
			.RelatedObjectTextWrapper {
				max-width: calc(100% - var(--px-60)) !important;
			}
		}
		.CountWrapper {
			margin-left: var(--px-10);
		}
	}
	/* .bodyTree {
		.tree-content {
			.gray-fade {
				&:nth-child(odd) {
					background-color: var(--neutrals-25);
				}
				&:nth-child(even) {
					background-color: var(--neutrals-00white);
				}
			}
		}
	} */
`;
